// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { thumbUp16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-thumb-up': IconThumbUp;
    }
}

/**
 * The icon component for the 'thumbUp' icon
 */
export class IconThumbUp extends IconSvg {
    public constructor() {
        super(thumbUp16X16);
    }
}

registerIconSvg('icon-thumb-up', IconThumbUp);
export const iconThumbUpTag = 'nimble-icon-thumb-up';
